import React from 'react';
import { Star } from 'lucide-react';
import { motion } from 'framer-motion';
const testimonials = [{
  name: 'Carlos M.',
  city: 'CDMX, MX',
  quote: 'Llevaba 3 años tomando pastillas. En la noche 4 del protocolo, me dormí sin darme cuenta. No lo podía creer.',
  weeks: '2 semanas'
}, {
  name: 'Andrea L.',
  city: 'Madrid, ES',
  quote: 'Lo que más me ayudó fue el audio de emergencia. Me desperté a las 3AM, lo puse, y a los 10 minutos estaba dormida otra vez.',
  weeks: '1 semana'
}, {
  name: 'Roberto S.',
  city: 'Santiago, CL',
  quote: 'Entendí que mi problema no era el sueño, era mi ansiedad por dormir. Al quitar la presión, el sueño volvió solo.',
  weeks: '3 semanas'
}, {
  name: 'Marta C.',
  city: 'Bogotá, CO',
  quote: 'Simple, directo y sin relleno. Fui directo a la fase 1 y esa misma noche descansé mejor.',
  weeks: '4 días'
}, {
  name: 'Luis P.',
  city: 'Lima, PE',
  quote: 'Ya no le tengo miedo a la noche. Eso para mí vale oro. Gracias por este manual.',
  weeks: '2 semanas'
}, {
  name: 'Daniela R.',
  city: 'Buenos Aires, AR',
  quote: 'Mi mente no paraba. La técnica de descarga mental es increíblemente efectiva.',
  weeks: '1 semana'
}];
export default function TestimonialsSection() {
  return <div className="py-10 px-4 sm:px-6 lg:px-8 bg-brand-dark" data-id="element-378">
      <div className="max-w-6xl mx-auto" data-id="element-379">
        <h3 className="font-heading text-2xl md:text-3xl text-white text-center mb-1 tracking-wide uppercase" data-id="element-380">
          Resultados reales
        </h3>
        <p className="text-sm text-slate-400 text-center mb-8" data-id="element-381">
          Personas que recuperaron sus noches
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-382">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.07,
          duration: 0.35
        }} className="bg-gradient-to-br from-brand-charcoal to-brand-dark rounded-xl p-6 border border-white/5 shadow-lg relative overflow-hidden group hover:border-brand-indigo/30 transition-colors" data-id="element-383">
              <div className="absolute top-0 right-0 w-20 h-20 bg-brand-indigo/5 rounded-full blur-2xl -mr-10 -mt-10 group-hover:bg-brand-indigo/10 transition-colors" data-id="element-384" />

              <div className="relative z-10" data-id="element-385">
                <div className="flex items-center gap-0.5 mb-3" data-id="element-386">
                  {[...Array(5)].map((_, i) => <Star key={i} size={12} className="fill-brand-amber text-brand-amber" data-id="element-387" />)}
                </div>
                <p className="text-slate-300 text-sm leading-relaxed mb-4 italic" data-id="element-388">
                  "{t.quote}"
                </p>
                <div className="flex items-center gap-3 border-t border-white/5 pt-3" data-id="element-389">
                  <div className="w-8 h-8 rounded-full bg-brand-indigo/20 flex items-center justify-center text-xs font-bold text-brand-indigo" data-id="element-390">
                    {t.name.charAt(0)}
                  </div>
                  <div data-id="element-391">
                    <p className="font-semibold text-white text-xs" data-id="element-392">{t.name}</p>
                    <p className="text-slate-500 text-[10px]" data-id="element-393">
                      {t.city} · {t.weeks}
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </div>;
}